import request from '@/util/http';

export default {
  verList,            //版本列表最多20条最新数据
  updateappversion,   //添加修改版本
}

function verList(data) {
  return request({
    url: "version/api/getversionlist",
    method: 'post',
    data
  })
}

function updateappversion(data) {
  return request({
    url: "sys/api/updateappversion",
    method: 'post',
    data
  })
}